import { Toaster } from "@/components/ui/toaster";
import { Outlet } from "react-router-dom";

/**
 * Two grounds, one product: the petrol panel carries the wordmark and what
 * the clinic is buying into; the form sits on the app ground so the first
 * screen already looks like the app it opens. Below `lg` the panel yields and
 * the form carries the mark itself.
 */
export function AuthLayout() {
  return (
    <div className="grid min-h-dvh bg-app-bg lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
      <aside className="relative hidden flex-col justify-between overflow-hidden bg-petrol px-12 py-12 text-white lg:flex">
        <img
          src="/media/logos/logo-white.png"
          width={168}
          height={57}
          alt="CliniSharp"
          className="h-auto w-[168px] object-contain"
        />
        <div className="max-w-[26rem]">
          <p className="font-display text-[2.5rem] font-medium leading-[1.06] tracking-[-0.02em] [text-wrap:balance]">
            Agenda, pacientes e crescimento, com uma equipe de IA que trabalha
            para a clínica.
          </p>
        </div>
        <ul className="space-y-2.5 text-[13px] leading-relaxed text-white/70">
          <li>Acesso em duas etapas: o código da clínica, depois o seu.</li>
          <li>A IA propõe; a equipe aprova.</li>
          <li>Uma agenda, um financeiro, um histórico por paciente.</li>
        </ul>
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -right-24 -top-24 size-80 rounded-full bg-white/[0.04]"
        />
      </aside>
      <section className="flex items-center justify-center px-4 py-10 sm:px-8">
        <Outlet />
      </section>
      <Toaster />
    </div>
  );
}
